<template>
  <div class="footer-container">
    <div class="footer">
      <div class="contact">
        <p style="margin-top: 1rem" class="mb-4">
          Chcesz być na bieżąco z aktualnym grafikiem zajęć, warsztatami i
          kursami? Zostaw swój adres e-mail:
        </p>
        <button
          type="submit"
          class="subscription-button"
          @click="moveToNewsletter"
        >
          Zapisz się do Newslettera
        </button>

        <div class="policy-links">
          <div class="link">
            <a href="">Polityka prywatności</a>
          </div>
          <div class="link-line"></div>
          <div class="link">
            <a href="">Regulamin</a>
          </div>
        </div>

        <p class="copyright">
          Copyright © {{ currentYear }}
          <a href="https://dagajoga.pl/">Daga Joga.</a>
        </p>
      </div>

      <div class="sysmo">
        <div class="sysmo-info">
          <a href="https://sysmo.pl/" target="_blank">
            <img
              src="../assets/sysmo-icon-v3.png"
              alt="Strona stworzona przez Sysmo.pl - Software house zajmujący się aplikacjami webowymi i platformami do sprzedaży kursów online"
          /></a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
export default {
  name: "Footer",
  methods: {
    redirectToMail() {
      window.location.href = "mailto:daga@dagajoga.pl";
    },
    redirectToFb() {
      window.open("https://www.facebook.com/Dagajoga", "_blank");
    },
    redirectToInsta() {
      window.open("https://www.instagram.com/dagajoga/", "_blank");
    },
    moveToNewsletter() {
      this.$router.push({ name: "Newsletter" });
    },
  },

  computed: {
    currentYear() {
      return moment().get("year");
    },
  },
};
</script>

<style type="text/scss" scoped>
.footer-container {
  display: flex;
  flex-direction: column;
  text-align: center;
  justify-content: center;
  font-family: "Inter", sans-serif;
  line-height: 1.5;
  width: 100vw;
  align-items: center;
  background: #c5c0b9;
}
.footer {
  width: 100%;
  display: flex;
  background: #c5c0b9;
  color: #373737;
  font-size: 16px;
  justify-content: space-between;
  font-weight: 400;
  align-items: flex-start;
  max-width: 1170px;
  padding: 60px 0px 20px 0;
}

.bolder {
  font-weight: 700;
}
.copyright-container {
  width: 1170px;
  max-width: 100vw;
  margin: auto;
  padding: 0px 0px;
}
.copyright {
  padding: 30px 0 0 0;
  font-size: 14px;
  margin-right: auto;
  background: inherit;
  color: #373737;
  text-align: left;
}
.copyright a {
  color: #373737;
  text-decoration: none;
}

.contact {
  display: flex;
  flex-direction: column;
  text-align: left;
  max-width: 45%;
}

.sysmo {
  text-align: center;
}
.sysmo-info {
  display: flex;
  align-items: center;
  justify-content: center;
}

.sysmo-info img {
  width: 300px;
  height: 70px;
}
.subscription-button {
  color: #373737;
  background: #d9d9d9;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 16px;
  cursor: pointer;
  font-size: 16px;
  font-weight: 400;
  text-align: center;
  text-decoration: none;
  overflow-wrap: break-word;
  box-sizing: border-box;
  max-width: 300px;
  margin-top: 20px;
  padding: 13px 36px 13px 36px;
  font-family: "Inter";
  font-style: normal;
  text-transform: none !important;
  transition: all 0.3s;
}
.subscription-button:hover {
  background: #e5e5e5;
}

.policy-links {
  margin: 30px 0;
}
.policy-links .link {
  padding: 15px 0;
}
.policy-links .link-line {
  width: 100%;
  height: 1px;
  background-color: #f3f3f3;
}
.policy-links .link a {
  font-size: 15px;
  color: #373737;
  transition: all 0.3s;
  text-decoration: none;
}
.policy-links .link a:hover {
  font-size: 15px;
  color: #f3f3f3;
}

@media screen and (max-width: 1200px) {
  .footer {
    padding: 50px 50px;
  }
  .copyright-container {
    padding: 0px 20px;
  }
}
@media screen and (max-width: 768px) {
  /* .sysmo{
    display: none;
  } */
}
@media screen and (max-width: 768px) {
  .footer {
    flex-direction: column;
    width: 100%;
    justify-content: center;
    align-items: center;
    padding: 50px 10px 0 10px;
  }
  .sysmo-info img {
    width: 200px;
    height: 50px;
    margin-left: auto;
  }
  .sysmo {
    margin-top: 50px;
    margin-left: auto;
    margin-bottom: 10px;
  }
  .contact {
    max-width: 95%;
  }
}
</style>
